module.exports = __webpack_public_path__ + "static/media/logo_cosechometro_new.87d709e4.png";